import {
    SET_REMOTE_ARTICLES,
    SET_ARTICLE_LOADER,
    SET_REMOTE_CATEGORIES,
    SET_CATEGORY_ID,
    SET_ARTICLE_SEARCH_QUERY,
    SET_CATEGORY_LOADER_STATUS,
} from "./mutation-types";

import axios from "axios";

const actions = {
    setCategoryFilter({ commit, state, dispatch }, { categoryId }) {
        commit(SET_CATEGORY_ID, { categoryId: categoryId });
    },
    setArticleSearchQuery({ commit, state, dispatch }, { searchQuery }) {
        commit(SET_ARTICLE_SEARCH_QUERY, { searchQuery: searchQuery });
    },
    loadArticles({ commit, state }) {
        commit(SET_ARTICLE_LOADER, { status: "loading" });
        axios
            .get("/api/v1/articles/", {
                params: {
                    q: state.textSearchQuery,
                    category: state.categoryId,
                },
            })
            .then((response) => {
                commit(SET_REMOTE_ARTICLES, {
                    remoteData: {
                        status: "success",
                        data: response.data,
                    },
                });
                commit(SET_ARTICLE_LOADER, { status: "completed" });
            })
            .catch((e) => {
                // TODO add error handling
                commit(SET_ARTICLE_LOADER, { status: "error" });
            });
    },
    loadCategories({ commit, state }) {
        commit(SET_CATEGORY_LOADER_STATUS, { status: "loading" });
        axios
            .get("/api/v1/categories/")
            .then((response) => {
                commit(SET_REMOTE_CATEGORIES, {
                    remoteData: {
                        status: "success",
                        data: response.data,
                    },
                });
                commit(SET_CATEGORY_LOADER_STATUS, { status: "completed" });
            })
            .catch((e) => {
                // TODO add error handling
                commit(SET_CATEGORY_LOADER_STATUS, { status: "error" });
            });
    },
};

export default actions;
